<template>
  <MyModal
    :title="title"
    height="auto"
    v-if="isShowPoint"
    :class="className"
    width="420px"
    @closeClick="handleCloseModalClick('point')"
  >
    <div class="mycontent">
      <!-- <div class="top-area">
        <div class="item">
          <div class="label">经纬度:</div>
          <div class="desc">
            <span> E{{ toFixed(config.lon, 6) }} </span>
            <el-divider direction="vertical"></el-divider>
            <span> N{{ toFixed(config.lat, 6) }} </span>
          </div>
        </div>
        <div class="item">
          <div class="label">高度:</div>
          <div class="desc">
            <el-select v-model="datasetHeight" placeholder="选择高度">
              <el-option
                v-for="(v, i) in heightList"
                :key="i"
                :label="v + 'm'"
                :value="v"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div> -->
      <div class="middle-area">
        <div class="row">
          <div class="row-item">
            <div class="key"><span>经度:</span></div>
            <div class="value">
              <span>{{ toFixed(config.lon, 6) }} </span>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>纬度:</span></div>
            <div class="value">
              <span>{{ toFixed(config.lat, 6) }} </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>高度:</span></div>
            <div class="value">
              <el-select v-model="datasetHeight" placeholder="选择高度" size="mini">
                <el-option
                  v-for="(v, i) in heightList"
                  :key="i"
                  :label="v + 'm'"
                  :value="v"
                ></el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="row-item">
            <div class="key"><span>高度:</span></div>
            <div class="value">
              <span> {{ datasetHeight || '-' }} m</span>
            </div>
          </div> -->
          <div class="row-item">
            <div class="key"><span>海拔:</span></div>
            <div class="value">
              <span>{{ summaryData.altitude || '-' }} m</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>空气密度:</span></div>
            <div class="value">
              <span> {{ summaryData.rhoair || '-' }} kg/m³ </span>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>平均风速:</span></div>
            <div class="value">
              <span> {{ summaryData.windSpeed || '-' }} m/s</span>
            </div>
          </div>
          <!-- <div class="row-item">
            <div class="key"><span>发电小时:</span></div>
            <div class="value">
              <span>{{ summaryData.fullLoadHour || '-' }} h </span>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>平均气温:</span></div>
            <div class="value">
              <span>{{ summaryData.t || '-' }} ℃</span>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>风切变:</span></div>
            <div class="value">
              <span>{{ summaryData.shearExp || '-' }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>A值:</span></div>
            <div class="value">
              <span>{{ summaryData.weibullA || '-' }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>K值:</span></div>
            <div class="value">
              <span>{{ summaryData.weibullK || '-' }}</span>
            </div>
          </div>
          <!-- <div class="row-item">
            <div class="key"><span>参考机型:</span></div>
            <div class="value">
              <span>{{ summaryData.turbineType || '-' }}</span>
            </div>
          </div> -->
        </div>
        <!-- <div class="row">
          <div class="row-item">
            <div class="key"><span>气压:</span></div>
            <div class="value">
              <span>{{ summaryData.pressure || '-' }} hPa</span>
            </div>
          </div>
          <div class="row-item">
            <div class="key"></div>
            <div class="value"></div>
          </div>
        </div> -->
      </div>
      <div v-if="showBottomArea">
        <div>
          <!-- 这部分信息移到了echart图表内-->
          <!-- <div class="plus-content">
          <div v-if="chartType === '威布尔分布'">
            <div class="AAndK">
              <div>A: {{ weibullA }}</div>
              <div>K: {{ weibullK }}</div>
            </div>
          </div>
          <div v-if="chartType === '风切变'">
            <div class="exp">
              <div>幂指数: {{ exp }}</div>
            </div>
          </div>
        </div> -->
          <div class="chart-content">
            <div class="chart-c">
              <Chart v-if="!loading" :option="chartOption"></Chart>
            </div>
          </div>
        </div>
        <div class="btn-area">
          <div
            v-for="(item, index) in btnList"
            :key="index"
            :class="[
              'btn-item',
              {
                'is-active': item.name === chartType
              }
            ]"
            @click="handleBtnClick(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="down-area" v-if="isLogin">
          <div>
            <el-button type="text" v-if="isTempItem" @click="handleSaveList">保存</el-button>
            <el-button type="text" v-if="!isTempItem" @click="handleDel">删除</el-button>
          </div>
        </div>
      </div>
    </div>

    <modal
      title="数据下载"
      :visible.sync="showDataDownLoadDialog"
      @close="dialogClose"
      width="400px"
    >
      <div class="data-content">
        <el-form
          ref="form"
          :rules="uploadrules"
          :model="uploadForm"
          label-width="120px"
        >
          <el-form-item label="数据集" prop="datasetCode">
            <el-select
              v-model="uploadForm.datasetCode"
              @change="handleDataDownChange"
            >
              <el-option
                v-for="(item, index) in dataDownSet"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="startDate">
            <el-date-picker
              v-model="uploadForm.startDate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              :default-value="defaultStartDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endDate">
            <el-date-picker
              v-model="uploadForm.endDate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              :default-value="defaultEndDate"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="vtn-wrp">
          <ct-button type="primary" :btnClick="handleDatasetClick"
            >下载</ct-button
          >
        </div>
      </div>
    </modal>
  </MyModal>
</template>

<script>
import moment from 'moment';
import MyModal from './modal';
import { mapGetters } from 'vuex';
import { toFixed, getQueryString } from '../utils';
import Chart from './chart';
// import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils';
export default {
  components: {
    MyModal,
    Chart
  },
  props: {
    title: {
      type: String,
      default: '资源概况'
    },
    itemConfig: {
      type: Object,
      default: () => ({})
    },
    fromProjectList: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    showBottomArea: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      exp: '',
      isShowPoint: true,
      uploadrules: {
        datasetCode: [
          { required: true, message: '请选择数据集', trigger: 'change' }
        ],
        startDate: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      uploadForm: {
        datasetCode: '',
        startDate: '',
        endDate: ''
      },
      defaultStartDate: '',
      defaultEndDate: '',
      weibullA: '',
      weibullK: '',
      dataDownSet: [],
      showDataDownLoadDialog: false,
      chartOption: {},
      datasetCode: '',
      datasetHeight: '',
      chartType: '风速季节变化',
      config: {
        itemName: '',
        lat: '',
        lon: '',
        datasetCode: '',
        datasetHeight: ''
      },
      summaryData: {
        altitude: '-',
        turbineType: '-',
        airTemperature: '-',
        powerDensity: '-',
        fullLoadHour: '-',
        loce: '-',
        pressure: '-',
        windSpeed: '-',
        airDensity: '-'
      },

      loading: false,

      heightList: [],
      btnList: [
        {
          name: '风向玫瑰图',
          chartOptions: data => {
            return {
              tooltip: {
                trigger: 'item',
                formatter: '角度:{b0} <br /> 频率:{c0} %'
              },
              textStyle: {
                color: '#606266',
                fontFamily: 'FangSong'
              },
              angleAxis: {
                type: 'category',
                data: data.sector,
                startAngle: -258.75,
                splitLine: {
                  show: true,
                  lineStyle: {
                    lineStyle: {
                      color: '#606266'
                    },
                    type: 'solid',
                    opacity: 1
                  }
                }
              },
              polar: {
                radius: 90,
              },
              radiusAxis: {
                z: 100
              },
              series: [
                {
                  type: 'bar',
                  data: data.frequency.map(i => toFixed(i, 2)),
                  coordinateSystem: 'polar'
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindDirectionRose',
          fileUrl: '/windfarm/meso/point/report/getWindDirectionRose',
          key: 'windDirectionRoseChart'
        },
        {
          name: '风能玫瑰图',
          chartOptions: data => {
            return {
              textStyle: {
                color: '#606266',
                fontFamily: 'FangSong'
              },
              tooltip: {
                trigger: 'item',
                formatter: '角度:{b0} <br /> 频率:{c0} %'
              },
              angleAxis: {
                type: 'category',
                data: data.sector,
                startAngle: -258.75,
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#606266',
                    type: 'solid',
                    opacity: 1
                  }
                }
              },
              polar: {
                radius: 90,
              },
              radiusAxis: {
                z: 100
              },
              series: [
                {
                  type: 'bar',
                  data: data.frequency.map(i => toFixed(i, 2)),
                  coordinateSystem: 'polar'
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindEnergyRose',
          fileUrl: '/windfarm/meso/point/report/getWindEnergyRose',
          key: 'windEnergyRoseChart'
        },
        {
          name: '风速季节变化',
          chartOptions: data => {
            const { powerDensity, windSpeed } = data;
            const mounths = new Array(12).fill('').map((i, index) => index + 1);

            return {
              grid: {
                right: '50',
                top: 40
              },
              legend: {
                textStyle: {
                  color: '#606266'
                },
                data: ['风功率密度', '风速'],
                bottom: 0,
                x: 'center',
                align: 'left'
              },
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const str = params
                    .map((serie, index) => {
                      return (
                        serie.marker +
                        serie.seriesName +
                        ':' +
                        serie.data +
                        (index === 0 ? 'm/s' : 'W/㎡')
                      );
                    })
                    .join('<br/>');

                  return str;
                }
              },
              xAxis: {
                nameLocation: 'end',
                boundaryGap: false,
                // nameTextStyle: {
                //   padding: [26, 0, 0, -10]  // 四个数字分别为上右下左与原位置距离
                // },
                // axisLabel: {
                //   padding:[0, 0, 0, 30]
                // },
                scale: true,
                type: 'category',
                // max: 12,
                // splitNumber: 12,
                name: '月份',
                data: mounths,
                axisTick: {
                  show: true
                },
                axisLine: {
                  lineStyle: {
                    color: '#606266'
                  }
                },
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: '#606266' //这里用参数代替了
                  }
                },
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: [
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {
                      color: '#606266'
                    }
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: '#606266' //这里用参数代替了
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  name: '风速(m/s)',
                  type: 'value'
                },
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {
                      color: '#606266'
                    }
                  },
                  axisLabel: {
                    show: true,
                    showMinLabel: false,

                    textStyle: {
                      color: '#606266' //这里用参数代替了
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },

                  name: '风功率密度(W/㎡)',
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '风速',
                  data: windSpeed.map(i => toFixed(i, 2)),
                  type: 'line',
                  smooth: true
                },
                {
                  yAxisIndex: 1,
                  name: '风功率密度',
                  data: powerDensity.map(i => toFixed(i, 2)),
                  type: 'line',
                  smooth: true
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindAndPowerMonth',
          fileUrl: '/windfarm/meso/point/report/getWindMonth',
          key: 'windMonthChart'
        },
        {
          name: '风速日变化',
          chartOptions: data => {
            const { powerDensity, windSpeed } = data;

            const days = new Array(24).fill('').map((i, index) => index);

            return {
              grid: {
                right: '50',
                top: 40
              },
              legend: {
                data: ['风功率密度', '风速'],
                textStyle: {
                  color: '#606266'
                },
                bottom: 0,
                x: 'center',
                align: 'left'
              },
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const str = params
                    .map((serie, index) => {
                      return (
                        serie.marker +
                        serie.seriesName +
                        ':' +
                        serie.data +
                        (index === 0 ? 'm/s' : 'W/㎡')
                      );
                    })
                    .join('<br/>');
                  return str;
                }
              },
              xAxis: {
                type: 'category',
                name: '小时',
                data: days,
                boundaryGap: false,
                axisTick: {
                  show: true
                },
                axisLabel: {
                  interval: 1
                },
                axisLine: {
                  lineStyle: {
                    color: '#606266'
                  }
                },
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: [
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {
                      color: '#606266'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  name: '风速(m/s)',
                  type: 'value'
                },
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {
                      color: '#606266'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: '#606266' //这里用参数代替了
                    }
                  },
                  name: '风功率密度(W/㎡)',
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '风速',
                  data: windSpeed.map(i => toFixed(i, 2)),
                  type: 'line',
                  smooth: true
                },
                {
                  yAxisIndex: 1,
                  name: '风功率密度',
                  data: powerDensity.map(i => toFixed(i, 2)),
                  type: 'line',
                  smooth: true
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindAndPowerDay',
          fileUrl: '/windfarm/meso/point/report/getWindDay',
          key: 'windDayChart'
        },
        // {
        //   name: '风频分布',
        //   chartOptions: (data) => {
        //     const { speed, frequency } = data;

        //     return {
        //       grid: {
        //         right: '70',
        //       },
        //       tooltip: {
        //         trigger: 'axis',
        //         formatter: '风速:{b0} m/s<br /> 频率:{c0} %',
        //       },
        //       xAxis: {
        //         name: '风速(m/s)',
        //         data: speed,
        //         // boundaryGap: false,
        //         splitLine: {
        //           lineStyle: {
        //             type: 'dashed',
        //           },
        //         },
        //       },
        //       yAxis: {
        //         min: 0,
        //         max: (value) => {
        //           if (value.max <= 10) {
        //             return 10;
        //           }

        //           let max = value.max * 1;
        //           let val = max / 5;
        //           const round = false;
        //           const exponent = Math.floor(Math.log(val) / Math.LN10);
        //           const exp10 = Math.pow(10, exponent);
        //           const f = val / exp10; // 1 <= f < 10
        //           let nf;
        //           if (round) {
        //             if (f < 1.5) {
        //               nf = 1;
        //             } else if (f < 2.5) {
        //               nf = 2;
        //             } else if (f < 4) {
        //               nf = 3;
        //             } else if (f < 7) {
        //               nf = 5;
        //             } else {
        //               nf = 10;
        //             }
        //           } else {
        //             if (f < 1) {
        //               nf = 1;
        //             } else if (f < 2) {
        //               nf = 2;
        //             } else if (f < 3) {
        //               nf = 3;
        //             } else if (f < 5) {
        //               nf = 5;
        //             } else {
        //               nf = 10;
        //             }
        //           }
        //           val = nf * exp10;
        //           return val * 5;
        //         },
        //         name: '频率(%)',
        //         type: 'value',
        //         splitLine: {
        //           lineStyle: {
        //             type: 'dashed',
        //           },
        //         },
        //       },
        //       series: [
        //         {
        //           data: frequency.map(i => toFixed(i, 2)),
        //           type: 'bar',
        //         },
        //       ],
        //     };
        //   },
        //   url: '/windfarm/meso/point/getWindFrequency',
        //   fileUrl: '',
        //   key: '',
        // },
        {
          name: '威布尔分布',
          chartOptions: data => {
            const {
              speed,
              frequency,
              weibullA = '',
              weibullK = '',
              weibullData = []
            } = data;
            this.weibullA = toFixed(weibullA, 2);
            this.weibullK = toFixed(weibullK, 2);
            //let subtext = 'A: ' + this.weibullA + '   K: ' + this.weibullK;
            return {
              /*grid: {
                right: '50',
                top: 40
              },*/
              legend: {
                data: [
                  {
                    name: '风速频率',
                    icon: 'circle'
                    // textStyle: {
                    //   color: '#63b8ff'
                    // }
                  },
                  {
                    name: '威布尔',
                    icon: 'circle'
                    // textStyle: {
                    //   color: '#ffd700'
                    // }
                  }
                ],
                textStyle: {
                  color: '#606266'
                },
                left: 'center',
                itemWidth: 15,
                itemHeight: 5,
                bottom: 0,
                align: 'left'
              },
              grid: {
                right: '70'
              },
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                name: '风速(m/s)',
                data: speed,
                // boundaryGap: false,
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#606266'
                  }
                },
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: '#606266' //这里用参数代替了
                  }
                }
              },
              yAxis: {
                min: 0,
                max: value => {
                  if (value.max <= 10) {
                    return 10;
                  }
                  let max = value.max * 1;
                  let val = max / 5;
                  const round = false;
                  const exponent = Math.floor(Math.log(val) / Math.LN10);
                  const exp10 = Math.pow(10, exponent);
                  const f = val / exp10; // 1 <= f < 10
                  let nf;
                  if (round) {
                    if (f < 1.5) {
                      nf = 1;
                    } else if (f < 2.5) {
                      nf = 2;
                    } else if (f < 4) {
                      nf = 3;
                    } else if (f < 7) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  } else {
                    if (f < 1) {
                      nf = 1;
                    } else if (f < 2) {
                      nf = 2;
                    } else if (f < 3) {
                      nf = 3;
                    } else if (f < 5) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  }
                  val = nf * exp10;
                  return val * 5;
                },
                name: '频率(%)',
                type: 'value',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#606266'
                  }
                },
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: '#606266' //这里用参数代替了
                  }
                }
              },
              series: [
                {
                  name: '风速频率',
                  data: frequency.map(i => toFixed(i, 2)),
                  type: 'bar'
                },
                {
                  name: '威布尔',
                  data: weibullData.map(i => toFixed(i, 2)),
                  type: 'line',
                  smooth: true
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWeibull',
          fileUrl: '/windfarm/meso/point/report/getWeibull',
          key: 'weibullChar'
        },
        {
          name: '风切变',
          chartOptions: data => {
            const { windSpeed, exp, shear = [], height = [] } = data;
            const heightArr = shear.map((item, index) => {
              return [item, height[index]];
            });
            this.exp = exp;
            //let subtext = '幂指数： α = ' + exp;
            // windSpeed.sort((a, b) => {
            //   return a[0] - b[0];
            // });

            // const x = windSpeed.map(i => i[0]);
            // const y = windSpeed.map(i => i[1]);

            return {
              /*grid: {
                right: '50',
                top: 40
              },*/
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const [x, y] = params[0].value;
                  return `风速${x}m/s, 高度${y}m`;
                }
              },
              grid: [
                {
                  left: '10%',
                  bottom: '20%',
                  top: '20%',
                  right: '20%'
                }
              ],
              xAxis: {
                type: 'value',
                name: '风速(m/s)',
                boundaryGap: false,
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#606266'
                  }
                },
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: '#606266' //这里用参数代替了
                  }
                }
              },
              yAxis: {
                min: 0,
                max: value => {
                  if (value.max <= 10) {
                    return 10;
                  }

                  let max = value.max * 1.2;
                  let val = max / 5;
                  const round = true;
                  const exponent = Math.floor(Math.log(val) / Math.LN10);
                  const exp10 = Math.pow(10, exponent);
                  const f = val / exp10; // 1 <= f < 10
                  let nf;
                  if (round) {
                    if (f < 1.5) {
                      nf = 1;
                    } else if (f < 2.5) {
                      nf = 2;
                    } else if (f < 4) {
                      nf = 3;
                    } else if (f < 7) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  } else {
                    if (f < 1) {
                      nf = 1;
                    } else if (f < 2) {
                      nf = 2;
                    } else if (f < 3) {
                      nf = 3;
                    } else if (f < 5) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  }
                  val = nf * exp10;
                  return val * 5;
                },
                type: 'value',
                name: '高度(m)',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#606266'
                  }
                },
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: '#606266' //这里用参数代替了
                  }
                }
              },
              series: [
                {
                  name: '高度',
                  type: 'line',
                  showSymbol: false,
                  smooth: true,
                  data: heightArr
                },
                {
                  name: '高度',
                  type: 'scatter',
                  data: windSpeed
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindShear',
          fileUrl: '/windfarm/meso/point/report/getWindShear',
          key: 'windShearChart'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', ['dataSet']),
    isTempItem() {
      return this.itemConfig.itemId?.indexOf?.('test') > -1;
    }
    // ...this.transConfig(this.config)
  },
  watch: {
    itemConfig: {
      handler(val) {
        if (!val) return;
        this.isShowPoint = true;
        this.config = val;
        this.chartType = '';
        const {
          datasetCode = '',
          datasetHeight = '',
          itemId = '',
          lat = '',
          lon = ''
        } = val;

        const item = this.dataSet?.find(
          item => item.datasetCode === datasetCode
        );
        this.heightList = item?.datasetHeight || [];

        if (!datasetCode) {
          const firstItem = this.dataSet?.[0] || {};
          this.config.datasetCode = firstItem?.datasetCode;
          this.datasetCode = this.config.datasetCode;
          this.heightList = firstItem?.datasetHeight;
          if (!datasetHeight) {
            this.config.datasetHeight = this.heightList?.[0] || '';
            this.datasetHeight = this.config.datasetHeight;
          }
        } else {
          this.datasetCode = this.config.datasetCode;
          this.datasetHeight = this.config.datasetHeight;
        }

        this.querySummaryData({
          datasetCode: this.datasetCode,
          datasetHeight: this.datasetHeight,
          itemId,
          lat,
          lon
        });
        this.handleBtnClick(this.btnList[0]);
      },
      immediate: true
    },
    datasetCode(val) {
      const { itemId = '', lat = '', lon = '' } = this.config;
      this.chartType = null;
      this.querySummaryData({
        datasetCode: val,
        datasetHeight: this.datasetHeight,
        itemId,
        lat,
        lon
      });

      this.config.datasetCode = val;
    },
    config: {
      handler(val) {
        this.$emit('update:itemConfig', val);
      }
    },
    datasetHeight(val) {
      const { itemId = '', lat = '', lon = '' } = this.config;
      this.chartType = null;
      this.querySummaryData({
        datasetCode: this.datasetCode,
        datasetHeight: val,
        itemId,
        lat,
        lon
      });

      this.config.datasetHeight = val;
      this.handleBtnClick(this.btnList[0]);
    }
  },
  methods: {
    handleCloseModalClick(modal) {
      if (modal === 'point') {
        this.isShowPoint = false;
        this.config = null;
      }
      if (modal === 'chart') {
        this.chartType = false;
      }
      this.$emit('handleCloseModalClick');
    },
    handleDataDownChange(val) {
      const item = this.dataDownSet.find(i => i.datasetCode === val) || {};

      this.defaultStartDate = item.startDate;
      this.defaultEndDate = item.endDate;

      this.uploadForm.startDate = this.defaultStartDate;
      this.uploadForm.endDate = this.defaultEndDate;
    },

    handleDatasetClick() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (
            moment(this.uploadForm.startDate).isBefore(this.defaultStartDate) ||
            moment(this.uploadForm.endDate).isAfter(this.defaultEndDate)
          ) {
            return this.$message.warning(
              `超出数据集的时间范围，范围应在${this.defaultStartDate}至${this.defaultEndDate}之间`
            );
          }

          if (
            moment(this.uploadForm.startDate).isAfter(this.uploadForm.endDate)
          ) {
            return this.$message.warning('结束时间不能超过开始时间');
          }

          const uploadForm = {
            ...this.uploadForm
          };

          uploadForm.startDate = uploadForm.startDate.replace(/-/g, '');
          uploadForm.endDate = uploadForm.endDate.replace(/-/g, '');

          const str =
            process.env.VUE_APP_API_HOST +
            '/windfarm/meso/point/getResourcesDataFile' +
            getQueryString({
              ...uploadForm,
              itemId: this.fromProjectList ? '0' : this.itemConfig.itemId,
              lat: this.itemConfig.lat,
              lon: this.itemConfig.lon,
              apiKey: getToken()
            });

          this.$message.warning('下载中，请稍等');
          window.open(str, '_parent');
        }
      });
    },
    dialogClose() {},
    toFixed,
    querySummaryData(params) {
      let myParams = params;

      if (this.fromProjectList) {
        this.$fetch('/windfarm/meso/point/getWindSummaryData', {
          showError: true,
          params: {
            ...myParams,
            itemId: '0',
            apiKey: getToken()
          },
          // noKey: this.fromProjectList
        }).then(res => {
          const { data = {} } = res;
          this.summaryData = data;
        });
      } else {
        this.$fetch('/windfarm/meso/point/getWindSummaryData', {
          showError: true,
          params: {
            ...myParams
          }
        }).then(res => {
          const { data = {} } = res;
          this.summaryData = data;
        });
      }
    },

    handleSelectChange(val) {
      const item = this.dataSet.find(item => item.datasetCode === val);
      this.heightList = item?.datasetHeight;
      this.config.datasetHeight = this.heightList[0] || '';
    },
    handleBtnClick(item) {
      if (this.chartType === item.name) {
        this.chartType = null;
      } else {
        this.chartType = item.name;
        this.queryChart(item);
      }
    },
    queryChart(item) {
      this.loading = true;

      const params = {
        datasetHeight: this.config.datasetHeight,
        datasetCode: this.config.datasetCode,
        itemId: this.config.itemId,
        lat: this.config.lat,
        lon: this.config.lon
      };

      this.$fetch(item.url, {
        showError: true,
        params: {
          ...params,
          itemId: this.fromProjectList ? '0' : params.itemId,
          apiKey: getToken()
        },
        // noKey: this.fromProjectList
      })
        .then(res => {
          this.loading = false;
          const { data } = res;
          this.chartOption = item.chartOptions(data) || {};
        })
        .catch(() => {
          this.loading = false;
        });
    },
    downReport(obj) {
      this.$postForm('/windfarm/meso/point/report/downReport', {
        showError: true,
        noJudge: true,
        responseType: 'blob',
        data: obj
      })
        .then(res => {
          const blob = new Blob([res.data]);

          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);
          link.target = '_blank';
          link.href = fileURL;
          let obj = this.dataSet.find(item => {
            return item.datasetCode === this.form.datasetCode;
          });
          link.download =
            this.rawData.name +
            '-' +
            obj.datasetName +
            '-' +
            this.form.datasetHeight +
            'm-点资源报告.doc'; //名称-数据集-高度-点资源报告
          link.click();
        })
        .catch(() => {});
    },
    handleSaveList() {
      this.itemConfig.noSave = false;
      this.$emit('saveList', this.itemConfig);
    },
    handleDel() {
      this.$emit('del', this.itemConfig.itemId);
    }
  }
};
</script>

<style lang="less" scoped>
.top-area {
  padding: 0px 20px 10px 20px;

  .item {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 3px 0px;
    .label {
      color: #000;
      width: 48px;
      text-align: right;
      margin-right: 10px;
    }
    .desc {
      color: #555;
    }
  }
}
.AAndK,
.exp {
  display: flex;
  color: @black-color;
  padding-left: 20px;
  div:first-child {
    margin-right: 15px;
  }
}
.middle-area {
  padding: 0px 10px;
  color: @black-color;
  .row {
    padding: 5px 0px;
    display: flex;
    align-items: center;
    .row-item {
      flex: 1;
      display: flex;
      align-items: center;
      &:nth-of-type(2n + 1) {
        flex: 1;
      }
      .key {
        span {
          width: 80px;
          display: inline-block;
        }
      }
      .value {
        flex: 1;
      }
      &:nth-of-type(2n) {
        margin-left: 10px;
      }
    }
  }
}

.btn-area {
  display: none;
  padding: 10px 10px;
  .btn-item {
    //user-select: none;
    display: inline-block;
    padding: 5px;
    line-height: 20px;
    width: 116px;
    text-align: center;
    border-radius: 4px;
    background: #133c62;
    color: #fff;
    cursor: pointer;
    margin-bottom: 13px;
    &:nth-child(3n + 1) {
      margin-right: 5px;
    }
    &:nth-child(3n + 2) {
      margin-right: 5px;
    }
    &.is-active {
      background-color: #1890ff;
      color: #fff;
    }
  }
}

.chart-modal {
  top: 0;
  right: -425px;
  left: unset;

  .plus-content {
    position: absolute;
    color: #fff;
    font-size: 12px;
    right: 30px;
    top: 80px;
    z-index: 2000;
    color: #000000;
  }
}
.chart-content {
  padding: 0 10px;
  height: 250px;
  .chart-c {
    height: 100%;
    padding: 0 5px;
    border-radius: 7px;
  }
}

.down-area {
  flex-direction: row-reverse;
  padding: 0px 20px;
  display: flex;
}

.data-content {
  padding: 10px;
}

.vtn-wrp {
  text-align: right;
  margin-top: 10px;
}
</style>
